import { render, staticRenderFns } from "./AddZonePage.vue?vue&type=template&id=172c3ea4&"
import script from "./AddZonePage.vue?vue&type=script&lang=js&"
export * from "./AddZonePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports